import React, { useEffect, useState } from "react";
// @material-ui/core components

// core components
import { Card, Grid } from "@material-ui/core";
import { CardBody, CardHeader, CardTitle, Input } from "reactstrap";
import { BASE_URL } from "../../variables/api";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Table from "../../Components/Tables/Table";

function EmployeeConfig(props: any) {
  const { classes } = props;
  const [isOnline, setIsOnline] = useState(false);
  const [data, setData] = useState([]);
  const [add, setAdd] = useState(false);
  const navigate = useNavigate();

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    Swal.showLoading();
    Swal.fire({
      title: "Do you want Save Your Changes ?",
      showDenyButton: true,
      confirmButtonText: `Confirm`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios
          .post(`${BASE_URL}/tickets/appointemployees.php`, data)
          .then(() => {
            Swal.fire("Configuration Added Successfully", "", "success").then(
              () => {
                setAdd(!add);
                navigate("/admin-tab");
              }
            );
          });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <>
      <Link
        style={{ marginTop: "2%" }}
        to="/admin-tab"
        className="btn btn-secondary mb-3"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>

      <form onSubmit={submitHandler}>
        <Card
          style={{
            width: "100%",
            border: "2px solid",
            borderColor: "#3278bd",
            backgroundColor: "lightgrey",
          }}
        >
          <div style={{ margin: "2%", overflowX: "auto" }}>
            <Table
              add={add}
              config={props.config}
              data={(data: any) => {
                setData(data);
              }}
            />
          </div>
        </Card>
        <div style={{ textAlign: "center", margin: "5%" }}>
          <Input
            style={{ minWidth: "50%" }}
            className="btn btn-primary"
            type="submit"
            vlaue="Submit"
          />
        </div>
      </form>
    </>
  );
}

export default EmployeeConfig;
